/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Heading2Inputs */

const zh_landing_admin_heading2 = /** @type {(inputs: Landing_Admin_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繁琐的事务却不是。`)
};

const en_landing_admin_heading2 = /** @type {(inputs: Landing_Admin_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The admin isn't.`)
};

const es_landing_admin_heading2 = /** @type {(inputs: Landing_Admin_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La burocracia no lo es.`)
};

/**
* | output |
* | --- |
* | "The admin isn't." |
*
* @param {Landing_Admin_Heading2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_heading2 = /** @type {((inputs?: Landing_Admin_Heading2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Heading2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_heading2(inputs)
	if (locale === "en") return en_landing_admin_heading2(inputs)
	return es_landing_admin_heading2(inputs)
});